import React from "react";
import _ from "lodash";

export const isMsgJson = (str: unknown): any | boolean | unknown => {
    try {
        return (JSON.parse(str.toString()) && !!str);
    } catch (e: any) {
        return false;
    }
}

export const errorMessageFromServer = (msg: unknown): any | React.ReactFragment => {
    if (!isMsgJson(msg)) {
        return msg;
    }

    return makeMessageServerError(msg);
}

export const convertJSONToString = (object: Object | any): string => {
    return JSON.stringify(object);
}

export const makeMessageServerError = (msg: unknown): React.ReactFragment => {
    const errorObject = JSON.parse(msg.toString());

    let errors = [];
    let message = null;
    if (errorObject?.message || errorObject?.errors) {
        message = (errorObject?.message) ? errorObject.message : null;
        const errorsObjects = (errorObject?.errors) ? errorObject.errors : null;

        if (errorsObjects) {
            errors = _.flatMapDeep(_.values(errorsObjects));
        }
    } else {
        errors = _.flatMapDeep(_.values(JSON.parse(msg.toString())));
    }

    return (
        <React.Fragment>
            <ul className={'snackbar-ul'}>
                {
                    (message) && <li key={`filepond-error-message`}><strong>{message}</strong></li>
                }
                {
                    _.map(errors, (error, index) => <li key={`filepond-error-${index}`}>{error}</li>)
                }
            </ul>
        </React.Fragment>
    );
}
